//This file contains cookie names which used in CI framework alphabetically

/**
 * If set to "1" then chat should be continued, checked onPageLanding in ChatMgr in IJSF
 * Values are (0|1) in string representation
 * @type {string}
 */
window.CHAT_CONTINUED = "c";

/**
 * If set to "1" then chat has been engaged by customer
 * Values are (0|1) in string representation
 * @type {string}
 */
window.CHAT_ENGAGED = "eng";

/**
 * If set to "1" then chat has been interacted (agent has responded)
 * Values are (0|1) in string representation
 * @type {string}
 */
window.CHAT_INTERACTED = "ai";

/**
 * If set to "1" chat has been loaded
 * Values are (0|1) in string representation
 * @type {string}
 */
window.CHAT_WINDOW_APPEARED = "cwa";

/**
 * If set then initial clickstream data has been already sent
 * See {@link com.inq.flash.client.control.ApplicationController.addClickStreamData}
 * @type {string}
 */
window.CLICK_STREAM_DATA_SENT_KEY = "s";

/**
 * Caller name for call chat
 * @type {string}
 */
window.CLIENT_NAME_PERSIST = "cn";

/**
 * Customer's name which should be displayed in CI
 * @type {string}
 */
window.CUSTOMER_DISPLAY_NAME = "ci_cdn";

/**
 * Stores email manager state
 * see {@link com.inq.flash.client.chatskins.EmailMgr.setCaptureState} for probable values
 * @type {string}
 */
window.EMAIL_MANAGER_CAPTURE_STATE = "emlc";

/**
 * Stores email manager state
 * see {@link com.inq.flash.client.chatskins.EmailMgr.setState} for probable values
 * @type {string}
 */
window.EMAIL_MANAGER_STATE = "eml";

/**
 * Skin path for embedded chat theme functionality
 * @type {string}
 */
window.EMBEDDED_SKIN_PATH = "skn_emb";

/**
 * Last received / set chat engagement parameters of current session.
 */
window.ENGAGE_CHAT_PARAMS = "ecp";

/**
 * Business unit id short name
 */
window.BUSINESS_UNIT_ID = "buId";

/**
 * Agent group id short name
 */
window.AGENT_GROUP_ID = "agId";

/**
 * Is skin font set to large. Values can be "0" or "1"
 * This is being used for tracking the new way of changing chat skin font size.
 * @type {string}
 */
window.FONT_SIZE_INCREASED = "fi";

/**
 * Skin height value
 * @type {string}
 */
window.HEIGHT = "h";

/**
 * Value of IFrame url to persist value of "autoAgentFrame" from MXML config
 * See {@link com.inq.flash.client.chatskins.SkinControl.InitializeAutomoton}
 * @type {string}
 */
window.IFRAME_URL = "ifrmurl";

/**
 * Initial CI timeout
 * Default is {@link com.inq.flash.client.chatskins.SkinControl.DEFAULT_INITIAL_TIMEOUT}
 * Could be overridden in MXML config as "initialTimeOut"
 * @type {string}
 */
window.INITIAL_TIMEOUT = "it";

/**
 * Set last timestamp when CI was focused
 * @type {string}
 */
window.LAST_FOCUSED = "lf";

/**
 * Set last timestamp when CI was touched (landing, message sent, message received)
 * @type {string}
 */
window.LAST_TOUCHED_TIME = "lt";

/**
 * Skin left position value
 * @type {string}
 */
window.LEFT = "l";

/**
 * Skin right position value
 * @type {string}
 */
window.RIGHT = "r";

/**
 * Chat message counter
 * @type {string}
 */
window.MESSAGE_COUNT = "msgcnt";

/**
 * Counter for minimize chat action
 * @type {string}
 */
window.MINIMIZED_COUNT = "mc";

/**
 * If set then sound is muted
 * @type {string}
 */
window.MUTE_SOUND = "m";

/**
 * Counter for opener scripts
 * @type {string}
 */
window.OPENER_SCRIPT_COUNT = "cntOS";

/**
 * If set then pre-chat survey was shown
 * @type {string}
 */
window.PRE_CHAT_SURVEY_SHOWN = "pss";

/**
 * If set then pre-chat survey was completed
 * @type {string}
 */
window.PRE_CHAT_SURVEY_COMPLETED = "psc";

/**
 * Queue messages counter
 * @type {string}
 */
window.QUEUE_MESSAGE_COUNT = "qmCnt";

/**
 * Last queue message ID
 * @type {string}
 */
window.QUEUE_MESSAGE_ID = "qmId";

/**
 * If set then chat is really minimized (restore button is not shown to customer)
 * See {@link com.inq.flash.client.control.MinimizeManager.actionReallyMinimize}
 * @type {string}
 */
window.REALLY_MINIMIZED = "rm";

/**
 * Skin path value
 * @type {string}
 */
window.SKIN_PATH = "skn";

/**
 * Skin top position value
 * @type {string}
 */
window.TOP = "t";

/**
 * Skin bottom position value
 * @type {string}
 */
window.BOTTOM = "b";

/**
 * Set when this is chat with virtual assistant
 * @type {string}
 */
window.VIRTUAL_AGENT = "va";

/**
 * Stores value of auth token for Web call (WebRTC functionality)
 * @type {string}
 */
window.WEB_CALL_AUTH_TOKEN = "watoken";

/**
 * Stores Web call mode when call started (WebRTC functionality)
 * Contains "AC" (audio call) or "VC" (video call) values
 * @type {string}
 */
window.WEB_CALL_MODE = "ewcall";

/**
 * Set when web call started (WebRTC functionality)
 * See {@link com.inq.flash.client.control.WebRTCMgr.processCallStarted}
 * @type {string}
 */
window.WEB_CALL_STARTED = "wcall";

/**
 * Stores value of WebCall URL (WebRTC functionality)
 * See {@link com.inq.flash.client.control.WebRTCMgr.processCallStarted}
 * @type {string}
 */
window.WEB_CALL_URL = "wcallUrl";

/**
 * Skin width position value
 * @type {string}
 */
window.WIDTH = "w";

/**
 * Stores URL parameters for request to XF server on XForm sync layer call
 * @type {string}
 */
window.XFORM_QUERY_STRING = "xfq";

/**
 * Stores list of XFrames and their state values
 * See {@link com.inq.flash.client.control.XFrameWorker.setPersistentState} for details
 * @type {string} */
window.XFRAMES = "xf";

/**
 * Stores initial customerId of conversation for async engagements
 * See {@link com.inq.flash.client.chatskins.SkinControl.parseConversationTranscript} for details
 * @type {string} */
window.INITIAL_CUSTOMER_ID = "iccid";

/**
 * Stores conversationId of conversation for async engagements
 * See {@link com.inq.flash.client.chatskins.SkinControl.parseConversationTranscript} for details
 * @type {string} */
window.CONVERSATION_ID = "cid";
